import React from 'react'

const ThreeStateToggle = ({ fld_id, value, onChange }) => {
	const options = [
		{ label: 'Yes',     val: '' 		},
		{ label: 'No',      val: 'None' 	},
		{ label: 'Unknown', val: 'Unknown' 	},
	]

	return (
		<div className="p-1 bg-light rounded-pill d-inline-block">
			<div className="btn-group" role="group" aria-label="Three state toggle">
				{options.map(opt => {
					const selected = value === opt.val
					return (
						<span
						key={opt.val}
						onClick={() => onChange(fld_id, opt.val)}
						className={[
							'text-center py-1 px-3',
							selected
							// selected button: white bg + slight drop shadow
							? 'rounded-pill shadow-sm ' + (opt.val == '' ? 'bg-primary text-white' : 'bg-secondary text-white')
							// unselected: Bootstrap secondary
							: 'rounded-pill text-secondary cursor-pointer'
						].join(' ')}
						style={{ minWidth: '80px' }}
						>
							{opt.label}
						</span>
					)
				})}
			</div>
		</div>
	)
}
export default ThreeStateToggle
